/** @jsxImportSource @emotion/react */
// import { useState, MouseEvent } from "react";
import { css } from '@emotion/react'
import { Stack, Typography } from '@mui/material'
import posterImgSrc from '../../../assets/images/poster.png'

type Info = { name: string; id: string }

const STUDIO_LIST: Info[] = [
  { name: '400VIEW', id: '400view' },
  {
    name: `boma pak studio(fldjf studio, WTM decoration & boma, Matter et cetera)`,
    id: 'qhakboma',
  },
  {
    name: '리슨투더시티(Listen to the City)',
    id: 'listentothecity',
  },
  { name: '릴레이', id: 'relay.works' },
  {
    name: `여성을 위한 열린 기술랩(WOMAN OPEN TECH LAB)`,
    id: 'womanopentechlab',
  },
  { name: '김을지로', id: 'uljiro' },
  { name: '도한결(모조산업)', id: 'mojoindustry' },
  { name: '불도저', id: 'meanyounglamb' },
  { name: '오늘의 풍경', id: 'sceneryoftoday' },
  { name: '프이치 스튜디오', id: 'studio_fych' },
  { name: '김지우', id: 'jjjjjjoy_kim' },
  { name: '소마킴', id: 'soma_kim' },
  { name: '이혜원', id: 'hang_a_e' },
  { name: '김희경(김희빛)', id: 'gellan_gum' },
  { name: '박민영', id: 'p_axpax' },
  { name: '유민(민)', id: 'artmin0000' },
]

const CREDIT_LIST: Info[] = [
  { name: '김지우', id: 'jjjjjjoy_kim' },
  { name: '소마킴', id: 'soma_kim' },
  { name: '이혜원', id: 'hang_a_e' },
  {
    name: '정해리(수퍼샐러드스터프 SUPERSALADSTUFF)',
    id: 'super_salad',
  },
]

const DESIGNER_LIST: Info[] = [
  {
    name: '수퍼샐러드스터프(SUPERSALADSTUFF)',
    id: 'supersaladstuff',
  },
]

const DEV_LIST: Info[] = [{ name: '김지우', id: 'jjjjjjoy_kim' }]

const TitleStyle = css`
  white-space: nowrap;
  font-size: 20px;
`

const captionStyle = css`
  font-size: 12px;
  white-space: pre-wrap;
`

const imgStyle = css`
  width: 100%;
  @media (min-width: 360px) {
    width: 350px;
  }
  @media (min-width: 720px) {
    width: 500px;
  }
  @media (min-width: 1440px) {
    width: 900px;
  }
  aspect-ratio: 4 / 5;
`

const paragraphStyle = css`
  word-break: break-word;
  gap: 8px;
  @media (min-width: 360px) {
    width: 340px;
  }
  @media (min-width: 720px) {
    width: 500px;
  }
  @media (min-width: 1440px) {
    width: 800px;
  }
`

const linkStyle = css`
  display: flex;
  align-items: center;
  &:link {
    color: #000;
    text-decoration: none;
  }
  &:visited {
    color: #000;
    text-decoration: none;
  }
  &:hover {
    color: #00f932;
    text-decoration: none;
  }
`

interface IntroProps {}

const Intro = (props: IntroProps) => {
  return (
    <Stack
      css={css`
        align-items: center;
        gap: 40px;
        padding: 16px 24px;
      `}
    >
      <img src={posterImgSrc} css={imgStyle} alt="open_studio_poster" />
      <Stack css={paragraphStyle}>
        <Typography css={TitleStyle}>
          <b>오픈스튜디오 Open Studio</b>
        </Typography>
        <Typography>2022.09.24(토) - 2022.09.25(일)</Typography>
        <Stack direction="row" alignItems="baseline" gap="4px">
          <Typography>12:00~19:00</Typography>
          <Typography css={captionStyle}>
            *스튜디오마다 조금씩 다릅니다.
          </Typography>
        </Stack>
        <Typography>
          서로의 근방에 위치한 16팀의 작업자들이 함께 오픈스튜디오를 진행합니다.
          24일~25일 양일간 각자 작업실을 열고, 찾아오는 방문객들을 환영합니다.
        </Typography>
      </Stack>

      <Stack css={paragraphStyle}>
        <Typography>
          <b>참여</b>
        </Typography>
        {STUDIO_LIST.map((v, i) => (
          <Stack direction="row" gap="4px" key={i}>
            <a
              href={`https://www.instagram.com/${v.id}`}
              target="blank"
              css={linkStyle}
            >
              {v.name}
            </a>
          </Stack>
        ))}
      </Stack>
      <Stack css={paragraphStyle}>
        <Typography>
          <b>기획/진행</b>
        </Typography>
        {CREDIT_LIST.map((v, i) => (
          <Stack direction="row" gap="4px" key={i}>
            <a
              href={`https://www.instagram.com/${v.id}`}
              target="blank"
              css={linkStyle}
            >
              {v.name}
            </a>
          </Stack>
        ))}
      </Stack>
      <Stack css={paragraphStyle}>
        <Typography>
          <b>그래픽 디자인</b>
        </Typography>
        {DESIGNER_LIST.map((v, i) => (
          <Stack direction="row" gap="4px" key={i}>
            <a
              href={`https://www.instagram.com/${v.id}`}
              target="blank"
              css={linkStyle}
            >
              {v.name}
            </a>
          </Stack>
        ))}
      </Stack>
      <Stack css={paragraphStyle}>
        <Typography>
          <b>웹제작</b>
        </Typography>
        {DEV_LIST.map((v, i) => (
          <Stack direction="row" gap="4px" key={i}>
            <a
              href={`https://www.instagram.com/${v.id}`}
              target="blank"
              css={linkStyle}
            >
              {v.name}
            </a>
          </Stack>
        ))}
      </Stack>
    </Stack>
  )
}

export default Intro
